// @generated by protoc-gen-connect-es v1.7.0 with parameter "target=ts,import_extension=none"
// @generated from file mono/capability/v1/capability.proto (package mono.capability.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
import { CreateCapabilityMatchRequest, CreateCapabilityMatchResponse, CreateCapabilityRequest, CreateCapabilityResponse, DeleteCapabilityRequest, DeleteCapabilityResponse, EnsureVendorLibraryProjectRequest, EnsureVendorLibraryProjectResponse, GetCapabilityGapAnalysisRequest, GetCapabilityGapAnalysisResponse, GetCapabilityRequest, GetCapabilityResponse, GetExtractionDashboardRequest, GetExtractionDashboardResponse, GetMatchQualityMetricsRequest, GetMatchQualityMetricsResponse, ListCapabilitiesRequest, ListCapabilitiesResponse, RecordExtractionMetricsRequest, RecordExtractionMetricsResponse, RunCapabilityMatchRequest, RunCapabilityMatchResponse, SubmitMatchFeedbackRequest, SubmitMatchFeedbackResponse, UpdateCapabilityRequest, UpdateCapabilityResponse } from "./capability_pb";
import { MethodKind } from "@bufbuild/protobuf";
/**
 * CapabilityService manages company capabilities, matching, feedback, and metrics.
 *
 * @generated from service mono.capability.v1.CapabilityService
 */ export const CapabilityService = {
    typeName: "mono.capability.v1.CapabilityService",
    methods: {
        /**
     * ======================== Capability CRUD ========================
     *
     * @generated from rpc mono.capability.v1.CapabilityService.CreateCapability
     */ createCapability: {
            name: "CreateCapability",
            I: CreateCapabilityRequest,
            O: CreateCapabilityResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.capability.v1.CapabilityService.GetCapability
     */ getCapability: {
            name: "GetCapability",
            I: GetCapabilityRequest,
            O: GetCapabilityResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.capability.v1.CapabilityService.ListCapabilities
     */ listCapabilities: {
            name: "ListCapabilities",
            I: ListCapabilitiesRequest,
            O: ListCapabilitiesResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.capability.v1.CapabilityService.UpdateCapability
     */ updateCapability: {
            name: "UpdateCapability",
            I: UpdateCapabilityRequest,
            O: UpdateCapabilityResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.capability.v1.CapabilityService.DeleteCapability
     */ deleteCapability: {
            name: "DeleteCapability",
            I: DeleteCapabilityRequest,
            O: DeleteCapabilityResponse,
            kind: MethodKind.Unary
        },
        /**
     * ======================== Vendor Document Processing ========================
     * Idempotent: returns the existing project if one exists for the company,
     * otherwise creates it. Safe to call concurrently from multiple services.
     *
     * @generated from rpc mono.capability.v1.CapabilityService.EnsureVendorLibraryProject
     */ ensureVendorLibraryProject: {
            name: "EnsureVendorLibraryProject",
            I: EnsureVendorLibraryProjectRequest,
            O: EnsureVendorLibraryProjectResponse,
            kind: MethodKind.Unary
        },
        /**
     * ======================== Matching & Gap Analysis ========================
     *
     * @generated from rpc mono.capability.v1.CapabilityService.CreateCapabilityMatch
     */ createCapabilityMatch: {
            name: "CreateCapabilityMatch",
            I: CreateCapabilityMatchRequest,
            O: CreateCapabilityMatchResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.capability.v1.CapabilityService.RunCapabilityMatch
     */ runCapabilityMatch: {
            name: "RunCapabilityMatch",
            I: RunCapabilityMatchRequest,
            O: RunCapabilityMatchResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.capability.v1.CapabilityService.GetCapabilityGapAnalysis
     */ getCapabilityGapAnalysis: {
            name: "GetCapabilityGapAnalysis",
            I: GetCapabilityGapAnalysisRequest,
            O: GetCapabilityGapAnalysisResponse,
            kind: MethodKind.Unary
        },
        /**
     * ======================== Feedback & Metrics ========================
     *
     * @generated from rpc mono.capability.v1.CapabilityService.SubmitMatchFeedback
     */ submitMatchFeedback: {
            name: "SubmitMatchFeedback",
            I: SubmitMatchFeedbackRequest,
            O: SubmitMatchFeedbackResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.capability.v1.CapabilityService.GetMatchQualityMetrics
     */ getMatchQualityMetrics: {
            name: "GetMatchQualityMetrics",
            I: GetMatchQualityMetricsRequest,
            O: GetMatchQualityMetricsResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.capability.v1.CapabilityService.RecordExtractionMetrics
     */ recordExtractionMetrics: {
            name: "RecordExtractionMetrics",
            I: RecordExtractionMetricsRequest,
            O: RecordExtractionMetricsResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.capability.v1.CapabilityService.GetExtractionDashboard
     */ getExtractionDashboard: {
            name: "GetExtractionDashboard",
            I: GetExtractionDashboardRequest,
            O: GetExtractionDashboardResponse,
            kind: MethodKind.Unary
        }
    }
};
